<template>
  <div class="wrapper">
    <div class="prompt">
      <div class="title">温馨提示</div>
      <div class="text">
        请妥善保管卡号卡密，切不可将券码信息交给其他人，谨防诈骗!
      </div>
    </div>

    <div class="detail">
      <div class="info">
        <div class="title">{{ detail.activityName || '-' }}</div>
        <div class="desc">
          商品有效期：{{
            common.formatDate(detail.effectiveEndTime, '{yyyy}-{mm}-{dd}')
          }}
        </div>
      </div>
      <div class="list">
        <div class="item" v-if="[0, 2, 3].includes(detail.gcShape)">
          <div class="label">卡号：</div>
          <div class="content">
            <div class="text">{{ detail.cardNo }}</div>
            <div
              class="button"
              v-clipboard:copy="detail.cardNo"
              v-clipboard:success="copySuccess"
              v-clipboard:error="copyError"
            >
              复制
            </div>
          </div>
        </div>
        <div class="item" v-if="[0, 1].includes(detail.gcShape)">
          <div class="label">卡密：</div>
          <div class="content">
            <div class="text">{{ detail.cardPwd }}</div>
            <div
              class="button"
              v-clipboard:copy="detail.cardPwd"
              v-clipboard:success="copySuccess"
              v-clipboard:error="copyError"
            >
              复制
            </div>
          </div>
        </div>
        <div class="item" v-if="[2, 3].includes(detail.gcShape)">
          <div class="label">短链：</div>
          <div class="content">
            <div class="text">{{ detail.fullNewShortUrl }}</div>
            <div
              class="button"
              v-clipboard:copy="detail.fullNewShortUrl"
              v-clipboard:success="copySuccess"
              v-clipboard:error="copyError"
            >
              复制
            </div>
          </div>
        </div>
        <div class="item" v-if="[3].includes(detail.gcShape)">
          <div class="label">验证码：</div>
          <div class="content">
            <div class="text">{{ detail.verifyCode }}</div>
            <div
              class="button"
              v-clipboard:copy="detail.verifyCode"
              v-clipboard:success="copySuccess"
              v-clipboard:error="copyError"
            >
              复制
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getOutStorageInfo } from '@/api'
export default {
  data() {
    return {
      detail: {}
    }
  },
  mounted() {
    this.loadDetail()
  },
  methods: {
    loadDetail() {
      /**
       * @param 商品名称
       * @param activityName - 名称
       * @param effectiveEndTime - 有效期
       * @param cardNo - 卡号
       * @param cardPwd - 卡密
       * @param verifyCode - 验证码
       * @param fullNewShortUrl - 短链
       */
      this.$toast.loading('加载中...')
      const { couponNo, code } = this.$route.query
      getOutStorageInfo(couponNo, code)
        .then(res => {
          if (res.code !== 0) return
          this.detail = res.data
        })
        .finally(() => {
          this.$toast.clear()
        })
    },
    copySuccess() {
      this.$toast({
        message: '复制成功'
      })
    },
    copyError() {
      this.$toast({
        message: '复制失败'
      })
    }
  }
}
</script>

<style lang="less" scoped>
.wrapper {
  height: 100%;
  min-height: 100vh;
  background-color: #ffdcab;
  padding: 30px;
  .prompt {
    height: 283px;
    border-radius: 30px;
    padding: 35px;
    background-color: #fff;
    .title {
      width: 297px;
      height: 70px;
      font-size: 40px;
      font-weight: bold;
      color: #371500;
      text-align: center;
      line-height: 70px;
      font-family: Source Han Sans CN;
      margin: 0 auto;
      background-image: url('~@/assets/img/ECoating/title_bg.png');
      background-size: 100% 100%;
    }
    .text {
      margin-top: 48px;
      font-size: 26px;
      color: #371500;
      font-weight: 400;
      line-height: 44px;
    }
  }
  .detail {
    margin-top: 30px;
    border-radius: 30px;
    padding: 30px 30px 71px;
    background-color: #fff;
    .info {
      position: relative;
      line-height: 1;
      padding-bottom: 42px;
      border-bottom: 1px dashed #dcdcdc;
      &::after {
        position: absolute;
        content: '';
        right: -41.5px;
        bottom: -11.5px;
        width: 23px;
        height: 23px;
        border-radius: 50%;
        background-color: #ffdcab;
      }
      &::before {
        position: absolute;
        content: '';
        left: -41.5px;
        bottom: -11.5px;
        width: 23px;
        height: 23px;
        border-radius: 50%;
        background-color: #ffdcab;
      }
      .title {
        font-size: 36px;
        color: #371500;
        margin-top: 9px;
      }
      .desc {
        font-size: 24px;
        color: #999;
        margin-top: 18px;
      }
    }
    .list {
      .item {
        display: flex;
        justify-content: space-between;
        line-height: 1;
        align-items: center;
        margin-top: 65px;
        &:first-child {
          margin-top: 41px;
        }
        .label {
          font-size: 24px;
          color: #999999;
        }
        .content {
          display: flex;
          align-items: center;
          .text {
            font-size: 24px;
            color: #202638;
            font-weight: bold;
            font-family: OPPOSans;
          }
          .button {
            font-size: 24px;
            color: #ed471f;
            text-align: center;
            height: 36px;
            line-height: 36px;
            border-radius: 18px;
            padding: 0 12px;
            margin-left: 21px;
            border: 1px solid #ed471f;
          }
        }
      }
    }
  }
}
</style>
